import {
  createUploadRecord,
  getCurrentStatus,
  getCurrentVersion,
  getRecord,
  getUpgradeLog,
  getUpgradePackage,
  getUpgradeRecord,
  notifyUpgrade,
  updateUploadStatus,
} from '@/api/account-center/system-upgrade'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { t } from '@/i18n'

// 获取升级记录
export const useGetUpgradeRecord = () => {
  const { runAsync: run } = useRequest(
    (params: { page: number; limit: number }) => getUpgradeRecord(params),
    {
      manual: true,
      onError: (error: any) => {
        Message.error(error.msg || t('获取升级记录失败'))
      },
    },
  )

  return [run] as const
}

// 获取记录日志
export const useGetUpgradeLog = () => {
  const { runAsync: run } = useRequest((id: string) => getUpgradeLog(id), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取记录日志失败'))
    },
  })

  return [run] as const
}

// 通知升级
export const useNotifyUpgrade = () => {
  const { runAsync: run, loading } = useRequest((id: string) => notifyUpgrade(id), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('通知升级失败'))
    },
  })

  return [run, loading] as const
}

// 修改上传状态
export const useUpdateUploadStatus = () => {
  const { runAsync: run, loading } = useRequest(
    (id: string, status: number) => updateUploadStatus(id, { status }),
    {
      manual: true,
      onError: (error: any) => {
        Message.error(error.msg || t('修改上传状态失败'))
      },
    },
  )

  return [run, loading] as const
}

// 获取升级包详情
export const useGetUpgradePackage = () => {
  const { runAsync: run } = useRequest((id: string) => getUpgradePackage(id), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取升级包详情失败'))
    },
  })

  return [run] as const
}

//  获取当前版本信息
export const useGetVersion = () => {
  const { runAsync: run } = useRequest(() => getCurrentVersion(), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取当前版本信息失败'))
    },
  })

  return [run] as const
}

// 获取记录
export const useGetRecord = () => {
  const { runAsync: run } = useRequest(params => getRecord(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取记录失败'))
    },
  })

  return [run] as const
}

// 创建上传记录
export const useCreateUploadRecord = () => {
  const { runAsync: run } = useRequest(() => createUploadRecord(), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('创建上传记录失败'))
    },
  })

  return [run] as const
}

// 获取当前状态
export const useGetSystemStatus = () => {
  const { runAsync: run } = useRequest(() => getCurrentStatus(), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取当前状态失败'))
    },
  })

  return [run] as const
}
